export default "__VITE_ASSET__706e07ca__"